module.exports = __webpack_public_path__ + "static/media/kitty.6ea37c93.gif";